import { render } from "./MyRegister_join.vue?vue&type=template&id=26bb635a"
import script from "./MyRegister_join.vue?vue&type=script&lang=js"
export * from "./MyRegister_join.vue?vue&type=script&lang=js"

import "./MyRegister_join.vue?vue&type=style&index=0&id=26bb635a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__